module.exports = __webpack_public_path__ + "media/entities/1407-986ca9a0.png";